export default "/packs/images/men-drinking~4b04d8837f20577d9ffb1e274b041d78.jpg";